import { communityTracks } from "@/shared/config/siteContent";
import { SectionCard } from "@/shared/ui/SectionCard";
import { SectionIntro } from "@/shared/ui/SectionIntro";

export function BlogsPage() {
  return (
    <div className="page-stack">
      <section className="hero-grid">
        <article className="hero-copy-panel">
          <p className="section-intro__eyebrow">Community / blogs</p>
          <h1 className="page-title">
            Profiles and posts should make the site feel inhabited by loyalists,
            not anonymous traffic.
          </h1>
          <p className="page-copy">
            Community is the public memory of the platform. Developer blogs,
            user blogs, titles, drafts, and editorial curation should all feel
            durable and ranked.
          </p>
        </article>

        <article className="editor-frame">
          <p className="section-card__eyebrow">Draft system</p>
          <h2>Static editor preview</h2>
          <p>
            New post creation starts writing immediately. Drafts autosave every
            five seconds and can later branch into publish or continue editing.
          </p>
          <ul className="editor-lines">
            <li>
              <strong>Post title</strong>
              <p>Unique title checked by backend before publish.</p>
            </li>
            <li>
              <strong>Post intro</strong>
              <p>Short subtitle slot for editorial framing.</p>
            </li>
            <li>
              <strong>Body + embeds</strong>
              <p>Images and Lichess board embeds later live in proper upload flows.</p>
            </li>
          </ul>
        </article>
      </section>

      <section className="section">
        <SectionIntro
          eyebrow="Tracks"
          title="Community should feel editorial and controlled, not like an ungoverned forum dump."
          description="The first version can still be static, but the route should already reflect different content types and moderation logic."
        />

        <div className="feature-grid">
          {communityTracks.map((track) => (
            <SectionCard key={track.title} eyebrow="Track" title={track.title}>
              <p>{track.body}</p>
            </SectionCard>
          ))}

          <SectionCard eyebrow="Permissions" title="Developer power remains visible in the product logic">
            <p>
              Developers can delete user blogs and publish developer or user
              posts. That hierarchy should be explicit in the eventual editor
              and moderation tooling.
            </p>
          </SectionCard>
        </div>
      </section>
    </div>
  );
}
